import React, { PropsWithChildren } from 'react';
import { ButtonBox } from './styles';

type Props = {
    disabled?: boolean;
    onClick: () => void;
}

export const Button = ({ disabled, children, onClick }: PropsWithChildren<Props>) => {
    const handleClick = () => {
        if (disabled) {
            return;
        }

        onClick();
    }

    return (
        <ButtonBox $disabled={Boolean(disabled)} onClick={handleClick}>
            {children}
        </ButtonBox>
    );
}
